import { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { NODE_TYPE_COLORS } from '@/types/docflow';
import type { INodeConfig } from '@/types/docflow';

interface DriveMoveNodeProps {
  data: {
    label: string;
    config: INodeConfig;
    selected?: boolean;
  };
}

const DriveMoveNode = memo(({ data }: DriveMoveNodeProps) => {
  const colors = NODE_TYPE_COLORS.drive_move;

  return (
    <div
      className={`px-4 py-3 rounded-lg border-2 shadow-md min-w-[180px] max-w-[220px] ${colors.bg} ${colors.border} ${
        data.selected ? 'ring-2 ring-cyan-400' : ''
      }`}
    >
      <Handle
        type="target"
        position={Position.Left}
        className="w-3 h-3 !bg-cyan-500"
      />

      <div className="flex items-center gap-2 mb-2">
        <svg className={`w-5 h-5 ${colors.text}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" />
        </svg>
        <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${colors.badge}`}>
          Drive Move
        </span>
      </div>

      <h4 className={`font-medium text-sm mb-1 ${colors.text}`}>
        {data.label}
      </h4>

      {data.config.destination_folder_name ? (
        <div className="text-xs text-gray-500 dark:text-gray-400 truncate">
          {data.config.destination_folder_name}
        </div>
      ) : (
        <div className="text-xs text-gray-400 dark:text-gray-500 italic">
          No destination set
        </div>
      )}
    </div>
  );
});

DriveMoveNode.displayName = 'DriveMoveNode';

export default DriveMoveNode;
